import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';

import { listenForAuthReturnUrl } from './app/core/services/return-url';
import { AppModule } from './app/app.module';
import { awsmobile } from './aws-exports';
import { environment } from './environments/environment';

Amplify.configure(awsmobile);
listenForAuthReturnUrl();

if (environment.production) {
  enableProdMode();
}

// // Log all emits for trubleshooting
// // Add this to your main.ts or a core initialization file
// import { EventEmitter } from '@angular/core';

// const originalEmit = EventEmitter.prototype.emit;
// EventEmitter.prototype.emit = function(value) {
//   console.log('EventEmitter emitting:', value);
//   return originalEmit.call(this, value);
// };

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
